'use strict';

var chunkZ6CB3LVR_js = require('./chunk-Z6CB3LVR.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var n = require('react');
var r = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var n__default = /*#__PURE__*/_interopDefault(n);
var r__default = /*#__PURE__*/_interopDefault(r);

var y=r__default.default.div.attrs(({$asLink:i,href:e,$disableCrawl:t,target:s})=>({as:i?"a":"div",href:i?e:void 0,rel:i&&t?"nofollow":void 0,target:i?s:void 0}))`
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: ${({$spaces:i})=>i.spacing_0_12};
  text-decoration: none;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: ${({$spaces:i})=>i.spacing_0};
    width: 100%;
    height: ${({$spaces:i})=>i.spacing_4};
    border-radius: ${({$variants:i})=>i.stripRadius};
    background:  ${({$variants:i})=>i.stripColor};
    visibility: ${({$isActive:i})=>i?"visible":"hidden"};
    opacity: ${({$isActive:i})=>i?1:0};
    transition: visibility 0.3s, opacity 0.3s;
  }

  &:hover::after {
    visibility: ${({$isActive:i})=>"visible"};
    opacity: ${({$isActive:i})=>1};
  }

  &:hover p {
    color: ${({$isActive:i,$activeColor:e})=>e};
  }

  @media (max-width: 1200px) {
    padding: ${({$spaces:i})=>i.spacing_4_12};

    &::after {
      visibility: ${({$isActive:i})=>i?"visible":"hidden"};
      opacity: ${({$isActive:i})=>i?1:0};
    }

    &:hover::after {
      visibility: hidden;
      opacity: 0;
    }

    &:hover p {
      color: ${({$variants:i})=>i.labelColor};
    }
  }

  @media (max-width: 767px) {
    padding: ${({$spaces:i,$isService:e})=>e?"0px":i.spacing_0_12_6};
    ${({$withBorder:i,$variants:e})=>i&&r.css`
        border: 1px solid ${e.containerBorder};
        border-radius: ${e.borderRadius};
    `}

    &::after {
      visibility: hidden;
      opacity: 0;
    }

    &:hover::after {
      visibility: hidden;
      opacity: 0;
    }
  }
`,u=r__default.default.img`
  width: ${({$sizes:i})=>i.extraLarge.iconSize};
  height: ${({$sizes:i})=>i.extraLarge.iconSize};
  margin: ${({$spaces:i})=>i.spacing_0_auto};

  @media (max-width: 1920px) {
    width: ${({$sizes:i})=>i.large.iconSize};
    height: ${({$sizes:i})=>i.large.iconSize};
  }

  @media (max-width: 1200px) {
    width: ${({$sizes:i})=>i.medium.iconSize};
    height: ${({$sizes:i})=>i.medium.iconSize};
  }

  @media (max-width: 767px) {
    width: ${({$sizes:i,$isService:e})=>e?"70px":i.small.iconSize};
    height: ${({$sizes:i,$isService:e})=>e?"60px":i.small.iconSize};
  }
  
  @media (max-width: 331px) {
    width: ${({$sizes:i})=>i.small.iconSize};
    height: ${({$sizes:i})=>i.small.iconSize};
  }
`,_=r__default.default.p`
  text-align: center;
  color: ${({$variants:i,$isActive:e,$activeColor:t})=>e?t:i.labelColor};
  font-size: ${({$sizes:i})=>i.extraLarge.labelSize};
  font-weight: ${({$sizes:i})=>i.extraLarge.labelWeight};
  line-height: ${({$sizes:i})=>i.extraLarge.labelHeight};

  @media (max-width: 1920px) {
    font-size: ${({$sizes:i})=>i.large.labelSize};
    font-weight: ${({$sizes:i})=>i.large.labelWeight};
    line-height: ${({$sizes:i})=>i.large.labelHeight};
  }

  @media (max-width: 1200px) {
    font-size: ${({$sizes:i})=>i.medium.labelSize};
    font-weight: ${({$sizes:i})=>i.medium.labelWeight};
    line-height: ${({$sizes:i})=>i.medium.labelHeight};
  }

  @media (max-width: 767px) {
    font-size: ${({$sizes:i})=>i.small.labelSize};
    font-weight: ${({$sizes:i})=>i.small.labelWeight};
    line-height: ${({$sizes:i})=>i.small.labelHeight};
    ${({$withBorder:i,$boldWeight:e})=>i&&r.css`
        font-weight: ${e};
    `}

     ${({$isService:i})=>i&&r.css`
         padding: 0 16px;
    `}
   
  }
`,C=r__default.default.img`
  position: absolute;
  top: 1px;
  right: 1px;
  width: ${({$sizes:i})=>i.extraLarge.badgeSize};
  height: ${({$sizes:i})=>i.extraLarge.badgeSize};

  @media (max-width: 1920px) {
    width: ${({$sizes:i})=>i.large.badgeSize};
    height: ${({$sizes:i})=>i.large.badgeSize};
  }

  @media (max-width: 1200px) {
    width: ${({$sizes:i})=>i.medium.badgeSize};
    height: ${({$sizes:i})=>i.medium.badgeSize};
  }

  @media (max-width: 767px) {
    width: ${({$sizes:i})=>i.small.badgeSize};
    height: ${({$sizes:i})=>i.small.badgeSize};
  }
`,H=({iconComponent:i=null,iconUrl:e="",label:t="",idx:s,badgeIcon:$="",withBorder:h=!1,asLink:l=!1,href:f="",onClickHandler:z=()=>{},isActive:c=!1,disableCrawl:S=!1,target:w="_self",isService:d=!1,imgLoadingType:v="eager"})=>{let{tokens:a}=chunkHUKGHOBJ_js.b(),{sizes:o,variants:b,spaces:m}=chunkZ6CB3LVR_js.a(a);return n__default.default.createElement(y,{$sizes:o,$variants:b,$withBorder:h,onClick:()=>{z(t,s);},$activeColor:a.text_brand_text_brand,$spaces:m,$asLink:l,href:l?f:void 0,$disableCrawl:S,$isActive:c,target:l?w:void 0,$isService:d},e?n__default.default.createElement(u,{loading:v,src:e,alt:`icon-${t}`,$sizes:o,$spaces:m,$isService:d}):i,$&&n__default.default.createElement(C,{src:$,alt:"badge",$sizes:o}),t&&n__default.default.createElement(_,{$sizes:o,$variants:b,$withBorder:h,$boldWeight:a.font_weight_semibold,$isActive:c,$activeColor:a.text_brand_text_brand,$isService:d},t))};

exports.a = H;
